import { Button, Dialog, DialogContent, DialogTitle } from '@mui/material';

import { useGetUserUtils, useQueryUserData } from '~/data/user';

import AuthService from '~/services/auth.service';

import { LOG, log } from '~/utils/logging';

export const DeactivatedAccountModal = () => {
  const { UserUtils } = useGetUserUtils();

  const { data: currentUser } = useQueryUserData(true);
  const featureFlags = currentUser?.featureFlags ?? {};
  const userInfo = currentUser?.userSettings ?? {};
  const userName = [userInfo?.firstName, userInfo?.lastName]
    .filter(Boolean)
    .join(' ');

  const logOut = () => {
    AuthService.logout();
  };

  const contactSupport = () => {
    log.productAnalyticsEvent(
      'Contact support for account activation',
      LOG.FEATURE.OTHER_FEATURE,
    );
    globalThis.location =
      'mailto:support@vestigas.com?subject=VESTIGAS-Vollversion';
  };

  return (
    <Dialog
      aria-describedby="deactivated-account-description"
      aria-labelledby="deactivated-account-modal-title"
      maxWidth="lg"
      open={Boolean(
        featureFlags.deactivatedCompanyAccount &&
        !UserUtils.isVestigasAccount(),
      )}
      scroll="paper"
    >
      <DialogTitle className="text-xl font-bold">
        {['Willkommen zurück', userName].filter(Boolean).join(', ')}
      </DialogTitle>
      <DialogContent>
        <div>
          Dein Account ist derzeit deaktiviert. Für den Fall, dass du
          <br />
          VESTIGAS weiterhin nutzen möchtest, kontaktiere bitte
          <br />
          den Support unter{' '}
          <span className="cursor-pointer font-bold" onClick={contactSupport}>
            support@vestigas.com
          </span>{' '}
          oder direkt
          <br />
          deine persönliche Ansprechperson bei VESTIGAS.
        </div>
        <div className="mt-4">Dein VESTIGAS Team</div>
        <div className="mt-4">
          <Button className="mr-8" variant="text" onClick={logOut}>
            Ausloggen
          </Button>
          <Button
            className="primary-button"
            color="primary"
            variant="contained"
            onClick={contactSupport}
          >
            Support kontaktieren
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
